<template>
  <v-container class="mt-4 px-5" fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title class="text-subtitle-1">
            Panel de autorizaciones
            <v-spacer></v-spacer>
            <v-btn color="primary" small rounded @click="abrirNueva">Solicitar</v-btn>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="autorizaciones"
              class="elevation-0"
              dense
              item-key="idautorizacion"
            >
              <template v-slot:item.requiere_presupuesto="{ item }">
                <v-chip small :color="item.requiere_presupuesto == 1 ? 'orange' : 'grey'" dark>
                  {{ item.requiere_presupuesto == 1 ? 'Sí' : 'No' }}
                </v-chip>
              </template>

              <template v-slot:item.estatus="{ item }">
                <v-chip small v-if="item.estatus == 1" color="green" dark>ACEPTADO</v-chip>
                <v-chip small v-else-if="item.estatus == 2" color="red" dark>NO ACEPTADO</v-chip>
                <v-chip small v-else>SIN REVISIÓN</v-chip>
              </template>

              <template v-slot:item.actions="{ item }">
                <v-icon small color="blue" @click="verItem(item)">mdi-eye</v-icon>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" max-width="720px">
      <v-card>
        <v-card-title>
          <span class="text-h6">{{ editedIndex === -1 ? 'Nueva autorización' : ('Folio: ' + editedItem.idautorizacion) }}</span>
          <v-spacer></v-spacer>
          <v-btn color="red" dark rounded small icon @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="black--text" v-if="editedIndex === -1">
          <v-autocomplete
            v-model="editedItem.id_dirigido"
            :items="usuarios"
            item-text="nombre_completo"
            item-value="id_usuario"
            label="A quién va dirigido"
            filled
            dense
            hide-details
            class="mb-4"
          ></v-autocomplete>

          <v-textarea
            v-model="editedItem.motivo"
            label="Motivo"
            filled
            hide-details
            rows="3"
            class="mb-4"
          ></v-textarea>

          <v-checkbox
            v-model="editedItem.requiere_presupuesto"
            label="Incluye o se necesita presupuesto"
            hide-details
            class="mt-0"
          ></v-checkbox>

          <div class="mt-4" v-if="!file">
            <div :class="['dropZone', dragging ? 'dropZone-over' : '']" @dragenter="dragging = true" @dragleave="dragging = false">
              <div class="dropZone-info" @drag="onChangeArchivo">
                <span class="dropZone-title blue--text"><b>Arrastra el archivo para cargar</b></span>
                <div class="dropZone-upload-limit-info">
                  <div>Imagen, PDF o video</div>
                  <div>Tamaño máximo: 50 MB</div>
                </div>
              </div>
              <input type="file" accept="image/*,.pdf,video/*" @change="onChangeArchivo">
            </div>
          </div>
          <div v-else class="mt-4">
            <v-btn color="red" class="mb-2" dense @click="quitarArchivo" fab small dark>
              <v-icon>mdi-delete</v-icon>
            </v-btn>
            <div class="text-body-2">{{ file.name }}</div>
            <v-img v-if="esImagenNueva" :src="vistaPrevia" contain max-height="220" class="mt-2"/>
          </div>
        </v-card-text>

        <v-card-text class="black--text" v-else>
          <span><b>Quién lo subió: </b>{{ editedItem.solicitante }}</span>
          <br/>
          <span><b>Dirigido a: </b>{{ editedItem.dirigido }}</span>
          <br/>
          <span><b>Fecha: </b>{{ editedItem.fecha_creacion }}</span>
          <br/>
          <span><b>Presupuesto: </b>{{ editedItem.requiere_presupuesto == 1 ? 'Sí' : 'No' }}</span>
          <br/>
          <span><b>Motivo: </b>{{ editedItem.motivo }}</span>
          <br/>
          <br/>
          <v-chip small v-if="editedItem.estatus == 1" color="green" dark>ACEPTADO</v-chip>
          <v-chip small v-else-if="editedItem.estatus == 2" color="red" dark>NO ACEPTADO</v-chip>
          <v-chip small v-else>SIN REVISIÓN</v-chip>
          <div v-if="editedItem.motivo_respuesta" class="mt-2">
            <b>Motivo de la respuesta: </b>{{ editedItem.motivo_respuesta }}
          </div>

          <div v-if="editedItem.archivo_adjunto" class="mt-4">
            <v-img
              v-if="editedItem.tipo_archivo === 'imagen'"
              :src="urlAdjunto + editedItem.archivo_adjunto"
              contain
              max-height="280"
            />
            <video
              v-else-if="editedItem.tipo_archivo === 'video'"
              :src="urlAdjunto + editedItem.archivo_adjunto"
              controls
              style="max-width: 100%; max-height: 280px;"
            ></video>
            <v-btn
              v-else
              :href="urlAdjunto + editedItem.archivo_adjunto"
              target="_blank"
              color="primary"
              small
              rounded
              text
            >
              <v-icon left small>mdi-file-pdf-box</v-icon>
              Ver archivo
            </v-btn>
          </div>

          <div v-if="puedoResponder" class="mt-4">
            <v-textarea
              v-model="motivoRespuesta"
              label="Motivo de la respuesta"
              filled
              hide-details
              rows="2"
              hint="Obligatorio si rechazas"
              persistent-hint
            ></v-textarea>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-btn color="red" dark rounded small @click="close">Cerrar</v-btn>
          <v-spacer></v-spacer>
          <template v-if="editedIndex === -1">
            <v-btn color="primary" dark rounded small @click="save">Solicitar</v-btn>
          </template>
          <template v-else-if="puedoResponder">
            <v-btn color="red" dark rounded small class="mr-2" @click="responder(2)">Rechazar</v-btn>
            <v-btn color="green" dark rounded small @click="responder(1)">Aceptar</v-btn>
          </template>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Alerta v-if="respuestaAlerta" :parametros="parametros"/>
    <carga v-if="cargar"/>
  </v-container>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import Alerta from '@/components/alertas/Alerta.vue'
import carga from '@/components/alertas/carga.vue'
import validarErrores from '@/mixins/validarErrores'

export default {
  components: { Alerta, carga },
  mixins: [validarErrores],

  data: () => ({
    parametros: { dialogError: false, mensaje: '', color: '' },
    respuestaAlerta: false,
    cargar: false,
    dialog: false,
    headers: [
      { text: 'ID', value: 'idautorizacion' },
      { text: 'Quién lo subió', value: 'solicitante' },
      { text: 'Dirigido a', value: 'dirigido' },
      { text: 'Motivo', value: 'motivo' },
      { text: 'Presupuesto', value: 'requiere_presupuesto' },
      { text: 'Fecha', value: 'fecha_creacion' },
      { text: 'Estatus', value: 'estatus' },
      { text: 'Actions', value: 'actions', sortable: false },
    ],
    autorizaciones: [],
    usuarios: [],
    editedIndex: -1,
    editedItem: {
      idautorizacion: '',
      id_dirigido: null,
      motivo: '',
      requiere_presupuesto: false,
    },
    file: null,
    dragging: false,
    vistaPrevia: null,
    esImagenNueva: false,
    urlAdjunto: '',
    motivoRespuesta: '',
  }),

  computed: {
    ...mapGetters('login', ['getdatosUsuarioERPERP']),
    puedoResponder () {
      if (this.editedIndex < 0) return false
      const yo = this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.iderp
      return Number(this.editedItem.id_dirigido) === Number(yo) && Number(this.editedItem.estatus) === 0
    },
  },

  created () {
    this.urlAdjunto = axios.defaults.baseURL + 'autorizaciones-adjuntos/'
    this.initialize()
    this.cargarUsuarios()
  },

  methods: {
    initialize () {
      this.autorizaciones = []
      this.cargar = true
      const id = this.getdatosUsuarioERPERP.iderp
      return this.$http.get('autorizaciones.mias/' + id).then(response => {
        this.autorizaciones = response.data
      }).catch(error => {
        this.validarError(error.response.data.message)
      }).finally(() => { this.cargar = false })
    },

    cargarUsuarios () {
      return this.$http.get('usuarios.activos').then(response => {
        this.usuarios = response.data || []
      }).catch(error => {
        this.validarError(error.response.data.message)
      })
    },

    abrirNueva () {
      this.editedIndex = -1
      this.editedItem = { idautorizacion: '', id_dirigido: null, motivo: '', requiere_presupuesto: false }
      this.quitarArchivo()
      this.dialog = true
    },

    verItem (item) {
      this.editedIndex = this.autorizaciones.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.motivoRespuesta = ''
      this.dialog = true
    },

    close () {
      this.dialog = false
      this.motivoRespuesta = ''
    },

    onChangeArchivo (e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files || !files.length) {
        this.dragging = false
        return
      }
      const file = files[0]
      const permitidos = ['image/jpeg', 'image/png', 'image/webp', 'image/gif', 'image/bmp', 'application/pdf', 'video/mp4', 'video/quicktime', 'video/webm', 'video/x-msvideo']
      if (permitidos.indexOf(file.type) < 0) {
        this.dragging = false
        return this.validarErrorDirecto('Solo se aceptan imagen, PDF o video')
      }
      if (file.size > 50 * 1024 * 1024) {
        this.dragging = false
        return this.validarErrorDirecto('El archivo supera 50 MB')
      }
      this.file = file
      this.esImagenNueva = file.type.indexOf('image/') === 0
      this.dragging = false
      if (this.esImagenNueva) {
        const reader = new FileReader()
        const me = this
        reader.onload = function () { me.vistaPrevia = reader.result }
        reader.readAsDataURL(file)
      } else {
        this.vistaPrevia = null
      }
    },

    quitarArchivo () {
      this.file = null
      this.vistaPrevia = null
      this.esImagenNueva = false
      this.dragging = false
    },

    save () {
      if (!this.editedItem.id_dirigido) return this.validarErrorDirecto('Indica a quién va dirigida')
      if (!this.editedItem.motivo || !String(this.editedItem.motivo).trim()) return this.validarErrorDirecto('Indica el motivo')

      this.cargar = true
      const formData = new FormData()
      if (this.file) formData.append('file', this.file)
      formData.append('id_usuario', this.getdatosUsuarioERPERP.iderp)
      formData.append('id_dirigido', this.editedItem.id_dirigido)
      formData.append('motivo', this.editedItem.motivo)
      formData.append('requiere_presupuesto', this.editedItem.requiere_presupuesto ? 1 : 0)

      return this.$http.post('autorizaciones.agregar', formData).then(response => {
        this.validarSuccess(response.data.message)
        this.close()
        this.initialize()
      }).catch(error => {
        const msg = error && error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : 'No se pudo guardar la autorización'
        this.validarError(msg)
      }).finally(() => { this.cargar = false })
    },

    responder (estatus) {
      if (estatus === 2 && (!this.motivoRespuesta || !String(this.motivoRespuesta).trim())) {
        return this.validarErrorDirecto('Indica el motivo del rechazo')
      }
      this.cargar = true
      return this.$http.post('autorizaciones.responder', {
        idautorizacion: this.editedItem.idautorizacion,
        id_dirigido: this.getdatosUsuarioERPERP.iderp,
        estatus: estatus,
        motivo_respuesta: this.motivoRespuesta || '',
      }).then(response => {
        this.validarSuccess(response.data.message)
        this.close()
        this.initialize()
      }).catch(error => {
        const msg = error && error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : 'No se pudo responder la autorización'
        this.validarError(msg)
      }).finally(() => { this.cargar = false })
    },
  },
}
</script>

<style scoped>
  .dropZone {
    width: 100%;
    height: 140px;
    position: relative;
    border: 2px dashed #eee;
  }
  .dropZone:hover { border: 2px solid #D8D8D8; }
  .dropZone-info {
    color: #A8A8A8;
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translate(0, -50%);
    text-align: center;
  }
  .dropZone input {
    position: absolute;
    cursor: pointer;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }
  .dropZone-over { background: #D8D8D8; opacity: 0.8; }
</style>
